import React, { useState, useCallback } from "react";
import CommonFormLabel from "../../components/formLabel";
import Input from "../../components/input";
import Textarea from "../../components/commonTextArea";
import ValidationFeedback from "../../components/validationFeedback";
import CommonButton from "../../components/commonButton";
import FileInput from "../../components/fileInput";
import { useDispatch } from "react-redux";
import {
  Modal,
  Toast,
  Form,
} from "react-bootstrap";
import { Formik } from "formik";
import { addTestimonial, getTestimonials } from "../../modules/Testimonial/testimonialSlice";
import { testimonialSchema } from "../../schema/validationSchemas";
import { Cancel01Icon } from "../../assets/icons";

export default function Add({
  show,
  handleClose,
  currentPage,
  searchTerm,
  limit,
  id,
}) {
  const [showSnackbar, setShowSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarVariant, setSnackbarVariant] = useState("success");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const dispatch = useDispatch();

  const token = localStorage.getItem('auth-token');

  const initialEventState = {
    client_name: "",
    client_message: "",
    client_image: "",
    client_address: "",
  };

  const handleModalClose = useCallback(() => {
    handleClose();
  }, [handleClose]);

  const handleSubmit = async (values, { setSubmitting, setErrors }) => {
      setIsSubmitting(true);
      await dispatch(addTestimonial(values)).then((res) => {
        if(res.payload && res.payload.success) {
          setSnackbarMessage(res.payload.message);
          setSnackbarVariant("success");
          setShowSnackbar(true);
          setSubmitting(false);
          setIsSubmitting(false);
          handleClose();
          const payload = {
            page: currentPage,
            search: searchTerm,
            limit: limit,
            token
          };
          dispatch(getTestimonials({ payload }));
        } else {
          setErrors(res.payload.data);
          setSnackbarMessage(res.payload.message);
          setSnackbarVariant("danger");
          setShowSnackbar(true);
          setSubmitting(false);
          setIsSubmitting(false);
        }
      }).catch((error) => {
        console.error("Error:", error);
        setSnackbarMessage("Failed to add testimonial!");
        setSnackbarVariant("danger");
        setShowSnackbar(true);
        setSubmitting(false);
        setIsSubmitting(false);
      })
  };

  return (
    <>
      <Toast
        onClose={() => setShowSnackbar(false)}
        show={showSnackbar}
        delay={3000}
        autohide
        bg={snackbarVariant}
        style={{ position: "fixed", top: 20, right: 20, zIndex: 1000 }}
      >
        <Toast.Body style={{ color: "white" }}>{snackbarMessage}</Toast.Body>
      </Toast>

      <Modal
        show={show}
        size="lg"
        centered
        dialogClassName="common-popup-dialog"
        contentClassName="common-popup-content"
        backdropClassName="common-popup-backdrop"
        onHide={handleModalClose}
      >
        
        <Modal.Body className="common-popup-body">
          <div className="position-absolute end-0 z-2 bg-white rounded-1 cursor-pointer d-flex align-items-center justify-content-center  common-popup-close-btn" onClick={handleModalClose}>
            <Cancel01Icon width={16} height={16} color="#BCBBC1" strokeWidth="2.5" />
          </div>
          <div className="mb-4 text-center common-popup-heading">
            <h4 className="text-capitalize mb-2 fw-medium">New Testimonial</h4>
            <p>Add new Testimonial</p>
          </div>
          <Formik
            initialValues={initialEventState}
            validationSchema={testimonialSchema}
            onSubmit={handleSubmit}
          >
            {({ errors, touched, handleChange, handleSubmit, values, setFieldValue }) => (
              <Form onSubmit={handleSubmit} encType="multipart/form-data">
                <div className="mb-4">
                  <CommonFormLabel htmlFor="client_name" title="Name" />
                  <Input
                    id="client_name"
                    name="client_name"
                    type="text"
                    placeholder="Enter Client Name"
                    onChange={handleChange}
                    className={`shadow-none ${errors?.client_name && touched.client_name ? 'error' : 'correct'}`}
                  />
                  {touched.client_name && errors?.client_name && (
                    <ValidationFeedback title={errors?.client_name} />
                  )}
                </div>

                <div className="mb-4">
                  <CommonFormLabel htmlFor="client_address" title="Address" />
                  <Textarea
                    id="client_address"
                    name="client_address"
                    value={values.client_address}
                    placeholder="Enter Address"
                    onChange={handleChange}
                    className={`shadow-none ${errors?.client_address && touched.client_address ? 'error' : 'correct'}`}
                    rows={4}
                  />
                  {touched.client_address && errors?.client_address && (
                    <ValidationFeedback title={errors?.client_address} />
                  )}
                </div>

                <div className="mb-4">
                  <CommonFormLabel htmlFor="client_message" title="Message" />
                  <Textarea
                    id="client_message"
                    name="client_message"
                    value={values.client_message}
                    placeholder="Enter message"
                    onChange={handleChange}
                    className={`shadow-none ${errors?.client_message && touched.client_message ? 'error' : 'correct'}`}
                    rows={4}
                  />
                  {touched.client_message && errors?.client_message && (
                    <ValidationFeedback title={errors?.client_message} />
                  )}
                </div>

                <div className="mb-4">
                  <CommonFormLabel htmlFor="client_image" title="Upload Image" />
                  <FileInput
                    name="client_image"
                    onChange={(file) => setFieldValue("client_image", file)}
                    error={errors?.client_image}
                    touched={touched.client_image}
                  />
                  {touched.client_image && errors?.client_image && (
                    <ValidationFeedback title={errors?.client_image} />
                  )}
                </div>

                <div className="d-flex align-items-center justify-content-center gap-3 common-popup-btn">
                  <CommonButton title={isSubmitting ? "Adding..." : "Add"} type="submit" disabled={isSubmitting} className="btn-primary primary-shadow" />
                  <CommonButton title="Cancel" onClick={handleModalClose} className="btn-muted" />
                </div>
              </Form>
            )}
          </Formik>
        </Modal.Body>
      </Modal>
    </>
  );
}
